function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return <svg className={styles["quote-chevronImage"] || "quote-chevronImage"} viewBox="0 0 39 39" xmlns="http://www.w3.org/2000/svg" {...props}><g fill="none" fillRule="evenodd"><path d="M0 39l12.574-19.5L0 0l39 19.5L0 39" fill="#4990e2" /><path d="M39 19.5L0 39l12.574-19.5" fill="#3e76b8" /></g></svg>;
});